import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface SettingItem {
  usdt_address: string;
  usdt_qr_img: string; // This will store the image URL or path from the server
}

const BankUSDT = () => {
  const [settings, setSettings] = useState<SettingItem>({
    usdt_address: '',
    usdt_qr_img: '',
  });
  const [qrFile, setQrFile] = useState<File | null>(null); // To store the uploaded file


  // Handle text input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  // Handle file input change base64
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0];
      setQrFile(file); // Set the file to state

      // Convert file to Base64 for preview
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setSettings((prevSettings) => ({
          ...prevSettings,
          usdt_qr_img: reader.result as string, // Store Base64 preview in state
        }));
      };
    }
  }

  


  
  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Create FormData to send both text data and file
    const formData = new FormData();
    formData.append('usdt_address', settings?.usdt_address);
    formData.append('payment_type', 'usdt'); // Assuming payment_type is always 'bank'
    if( qrFile ) {
      formData.append('usdt_qr_img', qrFile); // Append the file directly
    }

    try {
      const response = await axios.post(
        "https://api.trubetx.com/admin/addBankDetailsSettings",
        {
          usdt_address: settings.usdt_address,
          payment_type: 'usdt', // Send payment_type
          usdt_qr_img: settings.usdt_qr_img, // Send Base64 string as JSON
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setSettings((prevSettings) => ({
        ...prevSettings,
        usdt_qr_img: response?.data.usdt_qr_img, // Update with new image path from the server response
      }));
      alert('Settings updated successfully!');
      
    } catch (error) {
      console.error("Error updating settings:", error);
      alert('Failed to update settings.');
    }
  };

  return (
    <main className="flex ml-0 lg:ml-[230px]  overflow-auto bg-stone-100 pb-8">
    <div className="w-full flex-1 px-5">
      <div className="my-5">
        <div className="flex items-center justify-between">
          <div className="w-auto">
            <h1 className="font mb-3 flex flex-wrap items-center text-lg font-bold text-stone-800 md:text-xl">
              Add Bank USDT Details{" "}
            </h1>
          </div>
          <div className="w-auto" />
        </div>
        <div className="flex items-center gap-2">
          <a className="font-semibold text-cm-gray" href="/web/banking/create#">
            Banking<span className="ml-2">/</span>
          </a>
          <a className="font-semibold text-cm-gray" href="/web/banking/create#">
            Add Details
          </a>
        </div>
      </div>
       <section className="overflow-auto ">
        <form onSubmit={handleSubmit} className="shagow-lg relative rounded-lg bg-white py-1">
          <div className="grid gap-5 rounded-lg  p-5 sm:grid-cols-2">
            <div>
              <label className="text-gray-800">USDT Address</label>
              <input
                type='text'
                name='usdt_address'
                value={settings?.usdt_address}
                onChange={handleChange}
                className='border rounded p-2 w-full'
              />
            </div>
            <div>
              <label className="text-gray-800">QR Image</label>
              <input
                type='file'
                name='usdt_qr_img'
                onChange={handleFileChange}
                className='border rounded p-2 w-full'
              />
            </div>
            <div className="my-5 flex items-center justify-start gap-4">
              
              <button
                className="mantine-UnstyledButton-root mantine-Button-root rounded-lg mantine-1xk8bhn"
                type="submit"
                data-button="true"
              >
                <div className="bg-[#228be6] py-2 px-4 text-white rounded-lg mantine-Button-inner">
                  <span className="mantine-1ryt1ht mantine-Button-label">
                    Add Record
                  </span>
                </div>
              </button>
            </div>
          </div>
          </form>
        </section>
        
     
    </div>
    </main>
  );
};

export default BankUSDT;
